import { JBoxDropDown } from 'Core/Components/JBoxDropdown/DropDown';
import { VueApp } from 'VueApp';

export const useTooltip = ({ target, onClose }: { target: HTMLElement; onClose?: () => void }) => {
  const tooltip = new JBoxDropDown({
    target: target,
    onClose: onClose,    
    otherOptions: {
      position: {
        x: 'left',
        y: 'bottom',
      },
    },
  });

  return { tooltip };
};
